import React, { useLayoutEffect, useRef } from 'react';
import { useUpdate } from 'react-use';
import { i18n } from '../i18n/menubar';
import { useSticky } from '../react-utils/useSticky';
import { FlexToolbar } from '../toolbar';
import { stickyCn } from './sticky';
export function ToolbarView({ editor, editorType, toolbarEditor, toolbarFocus, toolbarConfig, hiddenActionsConfig, settingsVisible, className, children, stickyToolbar, }) {
    const rerender = useUpdate();
    useLayoutEffect(() => {
        editor.on('rerender-toolbar', rerender);
        return () => {
            editor.off('rerender-toolbar', rerender);
        };
    }, [editor, rerender]);
    const wrapperRef = useRef(null);
    const isStickyActive = useSticky(wrapperRef) && stickyToolbar;
    return (React.createElement("div", { ref: wrapperRef, className: stickyCn.toolbar({
            withSettings: settingsVisible,
            stickyActive: isStickyActive,
            isSticky: stickyToolbar,
        }, [className]) },
        React.createElement(FlexToolbar, { data: toolbarConfig, hiddenActions: hiddenActionsConfig, editor: toolbarEditor, focus: toolbarFocus, dotsTitle: i18n('more_action'), onClick: (id, attrs) => editor.emit('toolbar-action', { id, attrs, editorType }) }),
        children));
}
